import request from '@/utils/axios'
//获取书签
export function getBookmarkDataAll(params) {
    return request({
        url: 'api/Bookmarks/GetBookMarks',
        method: 'get',
        params: params
    })
}
//添加书签
export function addBookMark(params) {
    return request({
        url: 'api/Bookmarks/AddBookMark',
        method: 'post',
        data: params
    })
}
//删除书签
export function delBookMark(params) {
    return request({
        url: 'api/Bookmarks/DelBookMark',
        method: 'post',
        data: params
    })
}
//数据保存成地图的时候保存书签
export function AddBookMarkList(params) {
    return request({
        url: 'api/Bookmarks/AddBookMarkList',
        method: 'post',
        data: params
    })
}